import { render, staticRenderFns } from "./Sottotipocomponente.vue?vue&type=template&id=29be40bf&"
import script from "./Sottotipocomponente.vue?vue&type=script&lang=js&"
export * from "./Sottotipocomponente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports